import React, { SyntheticEvent } from 'react';
import PopupContainer from '../components/PopupContainer';
import ErrorMessage from '../components/ErrorMessage';
import CustomButton from './CustomButton';
import { FieldValidationErrorsType } from '../form/FrekulForm';

export type CustomUploadType = 'image'|'audio'|'video';

/**
 * ファイルアップロード
 */
function CustomUploadView({
  type,
  defaultPreviewImage = null,
  description,
  files = null,
  uploaded,
  deleted,
  onSelectFiles,
  onDeleteFiles,
}: {
  type: CustomUploadType,
  description: string,
  defaultPreviewImage?: string|null,
  files?: FileList|null,
  uploaded: boolean,
  deleted: boolean,
  onSelectFiles: (files: FileList) => void,
  onDeleteFiles: () => void,
}) {
  const [previewImage, setPreviewImage] = React.useState<string|null>(defaultPreviewImage);
  React.useEffect(() => {
    const selected = files !== null && files.length > 0;
    if ((uploaded || selected) && !deleted) {
      switch (type) {
        case 'image':
        {
          if (selected) {
            setPreviewImage(null);
            if (files[0].type.match('image.*')) {
              const reader = new window.FileReader();
              reader.onload = () => {
                setPreviewImage(reader.result as string);
              };
              reader.readAsDataURL(files[0]);
            }
          } else {
            setPreviewImage(defaultPreviewImage);
          }
          break;
        }
        case 'audio':
          setPreviewImage('/img/common/bg_music.jpg');
          break;
        case 'video':
          setPreviewImage('/img/common/bg_movie.jpg');
          break;
        default:
          setPreviewImage(null);
          break;
      }
    } else {
      setPreviewImage(null);
    }
  }, [uploaded, deleted, files]);

  const cancelEvent = (e: SyntheticEvent) => {
    e.stopPropagation();
    e.preventDefault();
  };
  const selected = (files !== null && files[0] !== null);
  const available = (uploaded || selected) && !deleted;
  let icon = '/img/common/icon_camera.svg';
  if (type === 'audio') {
    icon = '/img/common/icon_upload_music.svg';
  } else if (type === 'video') {
    icon = '/img/common/icon_movie.svg';
  }
  return (
    <div
      className="upload_area"
      style={available ? { background: '#f5f5f5' } : {}}
      onDrop={(e) => { cancelEvent(e); onSelectFiles(e.dataTransfer.files); }}
      onDragEnter={(e) => cancelEvent(e)}
      onDragOver={(e) => cancelEvent(e)}
      onDragLeave={(e) => cancelEvent(e)}
    >
      <img src={previewImage || undefined} alt="" />
      <div className="inner">
        <div className="text_up">
          <div className="text_up__inner">
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="upload__area">
              <img src={icon} alt="" />
              <input
                type="file"
                className="fileinput"
                onChange={(e) => {
                  if (e.target.files !== null) {
                    onSelectFiles(e.target.files);
                  } else {
                    onDeleteFiles();
                  }
                }
              }
              />
              {available ? '変更' : '選択'}
            </label>
            <p className="text_up__info">
              {selected ? files[0].name : description}
              {available && (
                <>
                  {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                  <button type="button" className="bt_trash" onClick={() => onDeleteFiles()}>
                    <img src="/img/common/icon_trash.svg" className="thumb_icon" alt="" />
                  </button>
                </>
              )}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function CustomUpload({
  type,
  defaultPreviewImage = null,
  description,
  files = null,
  uploaded = false,
  deleted = false,
  onSelectFiles,
  onDeleteFiles,
  validationErrors = {},
}: {
  type: CustomUploadType,
  description: string,
  defaultPreviewImage?: string|null,
  files?: FileList|null,
  uploaded?: boolean,
  deleted?: boolean,
  onSelectFiles: (files: FileList) => void,
  onDeleteFiles: () => void,
  validationErrors?: FieldValidationErrorsType,
}) {
  return (
    <>
      <CustomUploadView
        type={type}
        description={description}
        defaultPreviewImage={defaultPreviewImage}
        files={files}
        uploaded={uploaded}
        deleted={deleted}
        onSelectFiles={onSelectFiles}
        onDeleteFiles={onDeleteFiles}
      />
      <ErrorMessage type="error" validationErrors={validationErrors} />
    </>
  );
}

/**
 * 削除確認ポップアップ
 */
export function CustomUploadConfirmDeletionPopup({
  type,
  onDelete,
  onCancel,
}: {
  type: CustomUploadType,
  onCancel: () => void,
  onDelete: () => void,
}) {
  let title: string;
  let description: string;
  switch (type) {
    case 'image':
      title = '画像の削除';
      description = 'この画像を削除しますか？';
      break;
    case 'audio':
      title = '曲の削除';
      description = 'この曲を削除しますか？';
      break;
    case 'video':
      title = '動画の削除';
      description = 'この動画を削除しますか？';
      break;
    default:
      title = '削除';
      description = '削除しますか？';
      break;
  }
  return (
    <PopupContainer title={title} onClose={() => onCancel()}>
      <p>
        {description}
      </p>
      <p>
        いちど削除すると元に戻せません。
      </p>
      <form className="cake_ajax_form">
        <div className="form__body">
          <ul>
            <li className="bt">
              <CustomButton type="cancel-split" onClick={() => onCancel()}>キャンセル</CustomButton>
              <CustomButton type="default-split" onClick={() => onDelete()}>削除する</CustomButton>
            </li>
          </ul>
        </div>
      </form>
    </PopupContainer>
  );
}

